import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'

export function calculateProductCount(results) {
  const apiTotalResults = results?.pagination?.totalResults || 0
  const totalBanners =
    (results?.merchandising?.content?.inline?.length || 0) +
    (results?.merchandising?.content?.header?.length || 0) +
    (results?.merchandising?.content?.footer?.length || 0) +
    (results?.merchandising?.content?.banner?.length || 0)
  return Math.max(0, apiTotalResults - totalBanners)
}

export function ProductCount() {
  const { results } = useInfiniteScrollResults()
  const totalResults = calculateProductCount(results)

  return (
    <div className="text-xs text-neutral-secondary lg:text-s">
      {totalResults === 0
        ? 'No Products'
        : totalResults === 1
          ? '1 Product'
          : `${totalResults.toLocaleString()} Products`}
    </div>
  )
}
